import { useEffect, useState } from 'react';

// Returns true only after the component has mounted client-side.
// Use to gate Apollo queries and effects that must not run during SSR — Apollo
// observers created on the server are never torn down (no useEffect cleanup)
// and accumulate on the shared singleton cache, causing pod memory to grow.
export const useIsClient = (): boolean => {
  const [isClient, setIsClient] = useState(false);
  useEffect(() => {
    setIsClient(true);
  }, []);
  return isClient;
};
